import { useCallback } from 'react';
import { triggerSignUp } from '@fiverr-private/identification_triggers';
import { getContext } from '@fiverr-private/fiverr_context';
import { useLandingPage } from '../context/LandingPageContext';
import { reportIdentificationCompletedEvent } from '../utils/mixpanel';
import { useSessionStorage, SessionDataKeys } from './useSessionStorage';

export const useSignUp = () => {
    const { userId } = getContext();
    const { briefBoxInputValue, sellers, sellerIdsToExclude } = useLandingPage();
    const { cacheStorageData } = useSessionStorage();

    const signUp = useCallback(
        async (onSignUpSuccess: () => void) => {
            if (!userId) {
                triggerSignUp({
                    modalOptions: {
                        skipQuestionnaire: true,
                        afterSigningSuccess: () => {
                            reportIdentificationCompletedEvent();
                            cacheStorageData(SessionDataKeys.PAGE_DATA, {
                                generatedBrief: briefBoxInputValue,
                                sellers,
                                sellerIdsToExclude,
                            });
                            onSignUpSuccess();
                            window.location.reload();
                        },
                    },
                });
            }
        },
        [briefBoxInputValue, sellers, userId, cacheStorageData, sellerIdsToExclude]
    );

    return {
        signUp,
    };
};
